export const columns = [
  { accessorKey: "registrationNumber", header: "Vehicle", size: 140 },

  {
    accessorKey: "weBocId",
    header: "WeBOC ID (IGM#)",
    size: 210,
    accessorFn: (row: any) => ` ${row.weBocId || " "}`,
  },
  {
    accessorKey: "webocRMSColorCode",
    header: "WeBOC RMS Color Code",
    size: 255,
  },
  {
    accessorKey: "inspectorComments",
    header: "Customs Inspector Remarks",
    size: 280,
    accessorFn: (row: any) => ` ${row.inspectorComments || " "}`,
  },
  {
    accessorKey: "yardSlotInfo",
    header: "Yard",
    size: 120,
    accessorFn: (row: any) => ` ${row.yardSlotInfo || " "}`,
  },
  {
    accessorKey: "gdNumber",
    header: "GD#",
    size: 120,
    accessorFn: (row: any) => ` ${row.gdNumber || " "}`,
  },
  {
    accessorKey: "vehicleCleared",
    header: "Clearance",
    size: 160,
    type: "boolean",
  },
  {
    accessorKey: "actionButtons",
    header: "Action",
    size: 130,
    accessorFn: (row: any) => ` ${row.actionButtons || " "}`,
  },
];
